import React from 'react';
import { sanitizeString } from '../utils/security';
import { foldSearch, foldedSearchTokens } from '../utils/productPickerCore';

const safeText = (value) => sanitizeString(value ?? '');

/**
 * Arama metnindeki kelimelerin metin içinde geçtiği yerleri sarı ile vurgular (TR katlama ile).
 */
export function FoldedSearchHighlight({ text, queryRaw }) {
  const str = String(text ?? '');
  const tokens = foldedSearchTokens(queryRaw);
  if (!tokens.length) return <span style={{ wordBreak: 'break-word' }}>{safeText(str)}</span>;

  const folded = foldSearch(str);
  const tokenFolds = tokens.map((t) => foldSearch(t)).filter((t) => t.length > 0);
  if (folded.length !== str.length) {
    return <span style={{ wordBreak: 'break-word' }}>{safeText(str)}</span>;
  }

  const covered = new Array(str.length).fill(false);
  for (const tf of tokenFolds) {
    let pos = 0;
    while (pos < folded.length) {
      const idx = folded.indexOf(tf, pos);
      if (idx === -1) break;
      for (let k = 0; k < tf.length && idx + k < str.length; k += 1) {
        covered[idx + k] = true;
      }
      pos = idx + tf.length;
    }
  }

  const segments = [];
  let i = 0;
  while (i < str.length) {
    if (!covered[i]) {
      let j = i;
      while (j < str.length && !covered[j]) j += 1;
      segments.push({ h: false, t: str.slice(i, j) });
      i = j;
    } else {
      let j = i;
      while (j < str.length && covered[j]) j += 1;
      segments.push({ h: true, t: str.slice(i, j) });
      i = j;
    }
  }

  return (
    <span style={{ wordBreak: 'break-word' }}>
      {segments.map((seg, idx) =>
        seg.h ? (
          <mark
            key={`h-${idx}`}
            style={{
              backgroundColor: '#fef08a',
              color: '#1f2937',
              borderRadius: '3px',
              padding: '0 2px',
            }}
          >
            {safeText(seg.t)}
          </mark>
        ) : (
          <span key={`n-${idx}`}>{safeText(seg.t)}</span>
        )
      )}
    </span>
  );
}
